import { useNavigate } from '@exam-center/router';
import {
  Dialog,
  DialogContent,
  Flex,
  type DialogProps,
  Text,
  Button,
  DialogTitle,
  DialogActions,
} from '@shared/components';

export type AlreadyVerifiedModalProps = Pick<DialogProps, 'open'> & {
  examCenterCode: string;
  examEventId: string;
};

export default function AlreadyVerifiedModal(props: Readonly<AlreadyVerifiedModalProps>) {
  const { open, examCenterCode, examEventId } = props;

  const navigate = useNavigate();

  const handleClose = () => {
    navigate(`/:examCenterCode/proctoring/exam-events/:examEventId/e-kyc`, {
      params: {
        examCenterCode,
        examEventId,
      },
    });
  };

  return (
    <Dialog
      open={open}
      slotProps={{
        paper: {
          sx: { minWidth: '300px', maxHeight: 'fit-content' },
        },
      }}
      maxWidth='xs'
      onClose={handleClose}
    >
      <DialogTitle onClose={handleClose}>ผู้เข้าสอบรายนี้ได้รับการตรวจสอบแล้ว</DialogTitle>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'left',
          gap: theme.spacing(4),
          px: theme.spacing(6),
          py: theme.spacing(2),
        })}
      >
        <Flex
          sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(1), textAlign: 'left' })}
        >
          <Text variant='body1'>
            ไม่สามารถตรวจสอบซ้ำได้ <br />
            เนื่องจากผู้เข้าสอบรายนี้ได้รับการตรวจสอบจากผู้คุมสอบรายอื่นแล้ว
          </Text>
        </Flex>
      </DialogContent>
      <DialogActions>
        <Button size='large' onClick={handleClose}>
          รับทราบ
        </Button>
      </DialogActions>
    </Dialog>
  );
}
